import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const documentUrl =
  "/Prilozi/Model studentske prakse i prakticne nastave akademskih studija.pdf";
const futureStoriesRoute = "/iskustva-studenata-sa-prakse";

function ModelStudentskePrakse() {
  const [t] = useTranslation();

  const phaseCards = [
    {
      icon: "fa-building",
      title: t("modelPage.phases.phase1.title"),
      range: t("modelPage.phases.phase1.range"),
      lead: t("modelPage.phases.phase1.lead"),
      items: [
        t("modelPage.phases.phase1.item1"),
        t("modelPage.phases.phase1.item2"),
        t("modelPage.phases.phase1.item3"),
      ],
    },
    {
      icon: "fa-briefcase",
      title: t("modelPage.phases.phase2.title"),
      range: t("modelPage.phases.phase2.range"),
      lead: t("modelPage.phases.phase2.lead"),
      items: [
        t("modelPage.phases.phase2.item1"),
        t("modelPage.phases.phase2.item2"),
        t("modelPage.phases.phase2.item3"),
      ],
    },
    {
      icon: "fa-chart-line",
      title: t("modelPage.phases.phase3.title"),
      range: t("modelPage.phases.phase3.range"),
      lead: t("modelPage.phases.phase3.lead"),
      items: [
        t("modelPage.phases.phase3.item1"),
        t("modelPage.phases.phase3.item2"),
      ],
    },
    {
      icon: "fa-award",
      title: t("modelPage.phases.phase4.title"),
      range: t("modelPage.phases.phase4.range"),
      lead: t("modelPage.phases.phase4.lead"),
      items: [
        t("modelPage.phases.phase4.item1"),
        t("modelPage.phases.phase4.item2"),
        t("modelPage.phases.phase4.item3"),
      ],
    },
    {
      icon: "fa-graduation-cap",
      title: t("modelPage.phases.phase5.title"),
      range: t("modelPage.phases.phase5.range"),
      lead: t("modelPage.phases.phase5.lead"),
      items: [
        t("modelPage.phases.phase5.item1"),
        t("modelPage.phases.phase5.item2"),
        t("modelPage.phases.phase5.item3"),
      ],
    },
  ];

  const highlightCards = [
    {
      icon: "fa-building",
      title: t("modelPage.highlights.h1.title"),
      text: t("modelPage.highlights.h1.text"),
    },
    {
      icon: "fa-user-tie",
      title: t("modelPage.highlights.h2.title"),
      text: t("modelPage.highlights.h2.text"),
    },
    {
      icon: "fa-sitemap",
      title: t("modelPage.highlights.h3.title"),
      text: t("modelPage.highlights.h3.text"),
    },
    {
      icon: "fa-briefcase",
      title: t("modelPage.highlights.h4.title"),
      text: t("modelPage.highlights.h4.text"),
    },
  ];

  const outputCards = [
    {
      icon: "fa-file-alt",
      title: t("modelPage.outputs.o1.title"),
      text: t("modelPage.outputs.o1.text"),
    },
    {
      icon: "fa-certificate",
      title: t("modelPage.outputs.o2.title"),
      text: t("modelPage.outputs.o2.text"),
    },
    {
      icon: "fa-graduation-cap",
      title: t("modelPage.outputs.o3.title"),
      text: t("modelPage.outputs.o3.text"),
    },
    {
      icon: "fa-lightbulb",
      title: t("modelPage.outputs.o4.title"),
      text: t("modelPage.outputs.o4.text"),
    },
  ];

  const readableSections = [
    {
      title: t("model.title"),
      text: t("model.p1"),
      open: true,
    },
    {
      title: t("model.subtitle1"),
      text: t("model.p2"),
      open: false,
    },
    {
      title: t("model.subtitle2"),
      text: t("model.p3"),
      open: false,
    },
    {
      title: t("model.subtitle3"),
      text: t("model.p4"),
      open: false,
    },
  ];

  const usefulLinks = [
    { to: "/o-fpep", label: t("about.fpep") },
    { to: "/upis", label: t("upis.title") },
    { to: "/akreditacija-fpep", label: t("admission.Akreditacija") },
    { to: "/erasmus", label: t("saradnja.erasmus") },
    { to: "/projekti", label: t("saradnja.projekti") },
  ];

  return (
    <>
      <Navbar />
      <Bredcom
        title={t("modelPage.breadcrumbHome")}
        subtitle={t("modelPage.hero.title")}
      />

      <main className="practice-model-page">
        <div className="container mt-4 pt-40">
          <div className="row">
            <div className="col-lg-8 mb-4">
              <div className="pm-main">
                <section
                  className="pm-hero"
                  aria-label={t("modelPage.hero.aria")}
                >
                  <div className="pm-hero__content">
                    <div className="pm-eyebrowWrap">
                      <span className="pm-eyebrow">
                        {t("modelPage.hero.eyebrow")}
                      </span>
                      <span className="pm-badge">
                        {t("modelPage.hero.badge")}
                      </span>
                    </div>

                    <h1 className="pm-title">{t("modelPage.hero.title")}</h1>
                    <p className="pm-lead">{t("modelPage.hero.lead")}</p>

                    <div className="pm-heroActions">
                      <a
                        href={documentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pm-btn pm-btn--primary"
                      >
                        {t("modelPage.hero.ctaPrimary")}{" "}
                        <i className="fas fa-arrow-up-right-from-square" />
                      </a>

                      <a href="#phases" className="pm-btn pm-btn--ghost">
                        {t("modelPage.hero.ctaSecondary")}{" "}
                        <i className="fas fa-arrow-down" />
                      </a>
                    </div>

                    <div className="pm-statsGrid">
                      <div className="pm-statCard">
                        <span className="pm-statLabel">
                          {t("modelPage.hero.stats.s1.label")}
                        </span>
                        <strong>{t("modelPage.hero.stats.s1.value")}</strong>
                      </div>
                      <div className="pm-statCard">
                        <span className="pm-statLabel">
                          {t("modelPage.hero.stats.s2.label")}
                        </span>
                        <strong>{t("modelPage.hero.stats.s2.value")}</strong>
                      </div>
                      <div className="pm-statCard">
                        <span className="pm-statLabel">
                          {t("modelPage.hero.stats.s3.label")}
                        </span>
                        <strong>{t("modelPage.hero.stats.s3.value")}</strong>
                      </div>
                      <div className="pm-statCard">
                        <span className="pm-statLabel">
                          {t("modelPage.hero.stats.s4.label")}
                        </span>
                        <strong>{t("modelPage.hero.stats.s4.value")}</strong>
                      </div>
                    </div>
                  </div>

                  <div className="pm-hero__aside">
                    <div className="pm-sideHighlight">
                      <span className="pm-sideHighlight__label">
                        {t("modelPage.hero.aside.label")}
                      </span>
                      <h2>{t("modelPage.hero.aside.title")}</h2>
                      <p>{t("modelPage.hero.aside.text")}</p>
                    </div>
                  </div>
                </section>

                <section id="overview" className="pm-section">
                  <div className="pm-sectionHead">
                    <span className="pm-sectionEyebrow">
                      {t("modelPage.overview.eyebrow")}
                    </span>
                    <h2 className="pm-sectionTitle">
                      {t("modelPage.overview.title")}
                    </h2>
                    <p className="pm-sectionLead">
                      {t("modelPage.overview.lead")}
                    </p>
                  </div>

                  <div className="pm-overviewStack">
                    <div className="pm-surface pm-prose pm-prose--overview">
                      <p>{t("modelPage.overview.p1")}</p>
                      <p>{t("modelPage.overview.p2")}</p>

                      <div className="pm-callout pm-callout--inline">
                        <h3>{t("modelPage.overview.calloutTitle")}</h3>
                        <p>{t("modelPage.overview.calloutText")}</p>
                      </div>
                    </div>

                    <div className="pm-highlightGrid">
                      {highlightCards.map((card, index) => (
                        <article key={index} className="pm-highlightCard">
                          <div className="pm-iconWrap">
                            <i className={`fas ${card.icon}`} />
                          </div>
                          <h3>{card.title}</h3>
                          <p>{card.text}</p>
                        </article>
                      ))}
                    </div>
                  </div>
                </section>

                <section id="phases" className="pm-section">
                  <div className="pm-sectionHead">
                    <span className="pm-sectionEyebrow">
                      {t("modelPage.phases.eyebrow")}
                    </span>
                    <h2 className="pm-sectionTitle">
                      {t("modelPage.phases.title")}
                    </h2>
                    <p className="pm-sectionLead">
                      {t("modelPage.phases.lead")}
                    </p>
                  </div>

                  <div className="pm-phaseGrid">
                    {phaseCards.map((phase, index) => (
                      <article key={index} className="pm-phaseCard">
                        <div className="pm-phaseTop">
                          <div className="pm-phaseIcon">
                            <i className={`fas ${phase.icon}`} />
                          </div>
                          <span className="pm-phaseRange">{phase.range}</span>
                        </div>

                        <h3>{phase.title}</h3>
                        <p className="pm-phaseLead">{phase.lead}</p>

                        <ul className="pm-list">
                          {phase.items.map((item, itemIndex) => (
                            <li key={itemIndex}>{item}</li>
                          ))}
                        </ul>
                      </article>
                    ))}
                  </div>
                </section>

                <section id="outputs" className="pm-section">
                  <div className="pm-sectionHead">
                    <span className="pm-sectionEyebrow">
                      {t("modelPage.outputs.eyebrow")}
                    </span>
                    <h2 className="pm-sectionTitle">
                      {t("modelPage.outputs.title")}
                    </h2>
                    <p className="pm-sectionLead">
                      {t("modelPage.outputs.lead")}
                    </p>
                  </div>

                  <div className="pm-outputGrid">
                    {outputCards.map((card, index) => (
                      <article key={index} className="pm-outputCard">
                        <div className="pm-iconWrap pm-iconWrap--soft">
                          <i className={`fas ${card.icon}`} />
                        </div>
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                      </article>
                    ))}
                  </div>

                  <div className="pm-researchCard">
                    <div>
                      <span className="pm-miniBadge">
                        {t("modelPage.postgraduate.badge")}
                      </span>
                      <h3>{t("modelPage.postgraduate.title")}</h3>
                      <p>{t("modelPage.postgraduate.text")}</p>
                    </div>
                  </div>
                </section>

                <section id="documents" className="pm-section">
                  <div className="pm-sectionHead">
                    <span className="pm-sectionEyebrow">
                      {t("modelPage.documents.eyebrow")}
                    </span>
                    <h2 className="pm-sectionTitle">
                      {t("modelPage.documents.title")}
                    </h2>
                    <p className="pm-sectionLead">
                      {t("modelPage.documents.lead")}
                    </p>
                  </div>

                  <div className="pm-docGrid">
                    <a
                      href={documentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pm-docCard pm-docCard--link"
                    >
                      <div className="pm-docIcon">
                        <i className="fas fa-file-pdf" />
                      </div>
                      <div>
                        <h3>{t("modelPage.documents.primary.title")}</h3>
                        <p>{t("modelPage.documents.primary.text")}</p>
                        <span className="pm-inlineLink">
                          {t("modelPage.documents.primary.cta")}{" "}
                          <i className="fas fa-arrow-up-right-from-square" />
                        </span>
                      </div>
                    </a>

                    <article className="pm-docCard">
                      <div className="pm-docIcon pm-docIcon--gold">
                        <i className="fas fa-folder-open" />
                      </div>
                      <div>
                        <h3>{t("modelPage.documents.secondary.title")}</h3>
                        <p>{t("modelPage.documents.secondary.text")}</p>
                      </div>
                    </article>
                  </div>
                </section>

                <section id="readable" className="pm-section">
                  <div className="pm-sectionHead">
                    <span className="pm-sectionEyebrow">
                      {t("modelPage.readable.eyebrow")}
                    </span>
                    <h2 className="pm-sectionTitle">
                      {t("modelPage.readable.title")}
                    </h2>
                    <p className="pm-sectionLead">
                      {t("modelPage.readable.lead")}
                    </p>
                  </div>

                  <div className="pm-accordion">
                    {readableSections.map((section, index) => (
                      <details
                        key={index}
                        className="pm-details"
                        open={section.open}
                      >
                        <summary>
                          <span>{section.title}</span>
                          <i className="fas fa-plus" />
                        </summary>
                        <div className="pm-detailsBody">
                          <p>{section.text}</p>
                        </div>
                      </details>
                    ))}
                  </div>
                </section>

                <section id="stories" className="pm-section">
                  <div className="pm-comingSoon">
                    <span className="pm-miniBadge">
                      {t("modelPage.stories.badge")}
                    </span>
                    <h2>{t("modelPage.stories.title")}</h2>
                    <p>{t("modelPage.stories.text")}</p>

                    <div className="pm-comingSoonActions">
                      <Link
                        to={futureStoriesRoute}
                        className="pm-btn pm-btn--disabled"
                        onClick={(e) => e.preventDefault()}
                        aria-disabled="true"
                      >
                        {t("modelPage.stories.cta")}
                      </Link>
                      <span className="pm-comingSoonNote">
                        {t("modelPage.stories.note")}
                      </span>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <aside className="pm-sidebar">
                <div className="pm-sideCard pm-stickyCard">
                  <h3>{t("modelPage.sidebar.navTitle")}</h3>
                  <nav
                    className="pm-anchorNav"
                    aria-label={t("modelPage.sidebar.navAria")}
                  >
                    <a href="#overview">{t("modelPage.sidebar.navOverview")}</a>
                    <a href="#phases">{t("modelPage.sidebar.navPhases")}</a>
                    <a href="#outputs">{t("modelPage.sidebar.navOutputs")}</a>
                    <a href="#documents">
                      {t("modelPage.sidebar.navDocuments")}
                    </a>
                    <a href="#readable">{t("modelPage.sidebar.navReadable")}</a>
                    <a href="#stories">{t("modelPage.sidebar.navStories")}</a>
                  </nav>
                </div>

                <div className="pm-sideCard">
                  <h3>{t("modelPage.sidebar.docTitle")}</h3>
                  <p>{t("modelPage.sidebar.docText")}</p>
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pm-btn pm-btn--primary pm-btn--full"
                  >
                    {t("modelPage.sidebar.docCta")}{" "}
                    <i className="fas fa-file-pdf" />
                  </a>
                </div>

                <div className="pm-sideCard">
                  <h3>{t("modelPage.sidebar.linksTitle")}</h3>
                  <div className="pm-linkStack">
                    {usefulLinks.map((item, index) => (
                      <Link key={index} to={item.to} className="pm-sideLink">
                        <span>{item.label}</span>
                        <i className="fas fa-arrow-right" />
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="pm-sideCard">
                  <h3>{t("modelPage.sidebar.socialTitle")}</h3>
                  <div className="pm-socials">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="YouTube"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="TikTok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default ModelStudentskePrakse;
